import { prompt, type PromptDefinition } from './models';

export const HOMEOWNER_PROMPTS = [
    prompt(
        'Understand it',
        'What do the inspection reports say about the condition of this building?',
        'Which of my buildings have condition issues I should review first?'
    ),
    prompt(
        'Manage risk',
        'What safety checks should I follow up for this building?',
        'Which safety checks need my attention across my buildings?'
    ),
    prompt(
        'Keep it running',
        'What repairs are recorded as unresolved in this building?',
        'Which of my buildings have unresolved repairs?'
    ),
    prompt(
        'Find evidence',
        'Find homeowner handover documents for this building about…',
        'Find homeowner handover documents across my buildings about…',
        'prefill'
    ),
    prompt(
        'Keep it running',
        'What do the manuals recommend for routine care of this building?',
        'Compare routine care requirements across my buildings.'
    ),
    prompt(
        'Understand it',
        'Which warranties for this building are approaching expiry?',
        'Which warranties across my buildings expire soonest?'
    ),
    prompt(
        'Coordinate people',
        'Who should I contact about repairs to this building?',
        'Which repair contacts are recorded for each of my buildings?'
    ),
    prompt(
        'Find evidence',
        'Find warranty information for this building covering…',
        'Find warranty information across my buildings covering…',
        'prefill'
    ),
    prompt(
        'Understand it',
        'What do the available records say about alterations to this building?',
        'Which of my buildings have alterations with incomplete records?'
    ),
    prompt(
        'Manage risk',
        'Where are the emergency instructions for this building?',
        'Which of my buildings have missing or outdated emergency instructions?'
    ),
    prompt(
        'Understand it',
        "What should I ask about gaps in this building's handover records?",
        'Which of my buildings have the largest gaps in homeowner handover records?'
    ),
    prompt(
        'Find evidence',
        "Help me understand this building's inspection findings about…",
        'Help me compare inspection findings across my buildings about…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
